// Tileserver address and API key, fetched from the authenticated
// GET /v3/config/tileserver/ endpoint by AuthGate before the pages render.
// Kept out of the build-time env so the key never ships in the JS bundle.
//
// cogApiKey hører til API-ets egen COG-flisserver (/v3/tiles/...), som leverer
// rasterflisene til vindkartet. Mapbox kan ikke sette headere på en rasterkilde,
// så den nøkkelen må stå i URL-en — derfor hentes den samme vei som de andre.

let config = { url: "", apiKey: "", cogApiKey: "" };

export const setTilesConfig = (c) => {
	config = { ...config, ...c };
};

export const getTilesUrl = () => config.url;
export const getTilesApiKey = () => config.apiKey;
export const getCogApiKey = () => config.cogApiKey;
